import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import AnnouncementSummaries from 'rise-ui/components/announcement-summaries.gjs';
import UiPage from 'rise-ui/components/ui-page.gjs';

export default RouteTemplate(class IndexTemplate extends Component {
  <template>
    {{pageTitle "Find and Access Reclamation’s Open Data"}}

    <UiPage @page={{@model.home}}>
      <:title>Reclamation Information Sharing Environment (RISE)</:title>
      <:error>Home content could not be loaded. Please try back later.</:error>
      <:body>Loading Home content...</:body>
    </UiPage>

    <div>
      <h3 class="c-page-title qa-page-title">Announcements</h3>
      <AnnouncementSummaries
        @announcements={{@model.announcements}}
        @limit="2"
        @more="auto"
      />
    </div>

    {{outlet}}
  </template>
});
